// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.font-size-12[data-v-b9cb4322] {\n  font-size: 12px;\n}\n.font-size-11[data-v-b9cb4322] {\n  font-size: 11px;\n}\n.font-size-10[data-v-b9cb4322] {\n  font-size: 10px;\n}\n.text-blue[data-v-b9cb4322] {\n  color: #3d5ba5;\n}\n.disabled[data-v-b9cb4322] {\n    opacity: 0.5;\n    pointer-events: none;\n}\n", ""]);
// Exports
module.exports = exports;
